import { render, staticRenderFns } from "./QuickstartStepForm.vue?vue&type=template&id=b067bf64&scoped=true&"
import script from "./QuickstartStepForm.vue?vue&type=script&lang=js&"
export * from "./QuickstartStepForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b067bf64",
  null
  
)

export default component.exports